import { Component, Inject } from '@angular/core';
import { IErrorHandler } from '../../dataModels/contracts/IErrorHandler';

@Component({
    moduleId: module.id,
    selector: 'error-handler',
    templateUrl: 'error-handler.component.html'
})
export class ErrorHandler{

    toggleError: boolean = true;
    btnText : string;
    error: string;

    constructor(@Inject("IErrorHandler") handler: IErrorHandler) {

        handler.errorHandleRequest.subscribe(error => {
            this.btnText = 'UNEXPECTED_ERROR_Cancel';

            this.error = error;
            this.toggleError = false;
        });

        handler.notifyHandleRequest.subscribe(error => {
            this.btnText = 'UNEXPECTED_ERROR_OK';

            this.error = error;
            this.toggleError = false;
        });
    }

    onTryAgain() {
        window.location.reload(true);
    }

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/errorHandler/error-handler.component.ts